export const MOBILE_APP_PROMO_DISMISS_KEY = "plaatplan.mobileAppPromo.dismissedUntil";
export const MOBILE_APP_PROMO_DISMISS_MS = 24 * 60 * 60 * 1000;

export function readMobileAppPromoDismissedUntil() {
  try {
    const raw = window.localStorage.getItem(MOBILE_APP_PROMO_DISMISS_KEY);
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
}

export function isMobileAppPromoDismissed(now = Date.now()) {
  return readMobileAppPromoDismissedUntil() > now;
}

export function dismissMobileAppPromo(now = Date.now()) {
  try {
    window.localStorage.setItem(
      MOBILE_APP_PROMO_DISMISS_KEY,
      String(now + MOBILE_APP_PROMO_DISMISS_MS),
    );
  } catch {
    /* ignore quota / private mode */
  }
}
